module.exports = __webpack_public_path__ + "static/media/new-game-fill.a600592a.svg";